(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonial-carousel')) {
    customElements.define('testimonial-carousel', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.custom-testimonials__viewport');
        this.track = this.querySelector('.custom-testimonials__track');
        this.originals = [...this.track.children];
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.pointerStart = null;
        this.locked = false;

        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('pointerdown', (event) => {
          this.pointerStart = event.clientX;
        });
        this.viewport.addEventListener('pointerup', (event) => {
          if (this.pointerStart === null) return;
          const distance = event.clientX - this.pointerStart;
          this.pointerStart = null;
          if (Math.abs(distance) > 45) this.move(distance > 0 ? -1 : 1);
        });
        this.viewport.addEventListener('pointercancel', () => { this.pointerStart = null; });
        this.track.addEventListener('transitionend', (event) => {
          if (event.target === this.track) this.correctLoop();
        });

        this.resizeObserver = new ResizeObserver(() => {
          const perPage = window.matchMedia('(max-width: 768px)').matches ? 1 : 2;
          if (perPage !== this.perPage) this.build(perPage);
          else this.position(false);
        });
        this.resizeObserver.observe(this.viewport);
        this.build(window.matchMedia('(max-width: 768px)').matches ? 1 : 2);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      build(perPage) {
        this.perPage = Math.min(perPage, this.originals.length);
        this.track.querySelectorAll('[data-carousel-clone]').forEach((clone) => clone.remove());

        if (this.originals.length <= this.perPage) {
          this.index = 0;
          this.position(false);
          return;
        }

        const before = this.originals.slice(-this.perPage).map((slide) => this.cloneSlide(slide));
        const after = this.originals.slice(0, this.perPage).map((slide) => this.cloneSlide(slide));
        before.reverse().forEach((slide) => this.track.prepend(slide));
        after.forEach((slide) => this.track.append(slide));
        this.index = this.perPage;
        this.position(false);
      }

      cloneSlide(slide) {
        const clone = slide.cloneNode(true);
        clone.dataset.carouselClone = '';
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        return clone;
      }

      move(direction) {
        if (this.locked || this.originals.length <= this.perPage) return;
        this.locked = true;
        this.index += direction;
        this.position(true);
      }

      correctLoop() {
        const total = this.originals.length;
        if (this.index < this.perPage) this.index += total;
        if (this.index >= total + this.perPage) this.index -= total;
        this.position(false);
        this.locked = false;
      }

      position(animate) {
        const firstSlide = this.track.firstElementChild;
        if (!firstSlide) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = firstSlide.getBoundingClientRect().width + gap;
        this.track.style.transition = animate ? 'transform 420ms ease' : 'none';
        this.track.style.transform = `translate3d(${-this.index * step}px, 0, 0)`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
